export default "__VITE_ASSET__DEWGPOOp__"